<div class="login-page">
  <div class="login-container">
    <!-- Logo -->
    <div class="logo">
      <i class="fa fa-cubes"></i>
    </div>

    <!-- Welcome Text -->
    <div class="login-header">
      <h2>Bienvenue!</h2>
      <p>Connectez-vous à votre compte pour continuer</p>
    </div>

    <!-- Error Message -->
    <div class="error-container" *ngIf="errorMessage">
      <div class="error-message">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Login Form -->
    <form (ngSubmit)="onSubmit()" #loginForm="ngForm" class="login-form" autocomplete="off">
      <div class="form-group">
        <label for="username">Nom d'utilisateur ou Email</label>
        <div class="input-group">
          <i class="fa fa-user"></i>
          <input 
            type="text" 
            id="username"
            [(ngModel)]="username" 
            name="username" 
            placeholder="Entrez votre nom d'utilisateur ou email"
            autocomplete="off"
            required
            #usernameInput="ngModel">
        </div>
        <div class="error-hint" *ngIf="usernameInput.invalid && usernameInput.touched">
          Le nom d'utilisateur ou email est requis
        </div>

      </div>

      <div class="form-group">
        <label for="password">Mot de passe</label>
        <div class="input-group">
          <i class="fa fa-lock"></i>
          <input 
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            [(ngModel)]="password" 
            name="password" 
            placeholder="Entrez votre mot de passe"
            autocomplete="new-password"
            required
            #passwordInput="ngModel">
          <button 
            type="button" 
            class="password-toggle" 
            (click)="showPassword = !showPassword">
            <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
          </button>
        </div>
        <div class="error-hint" *ngIf="passwordInput.invalid && passwordInput.touched">
          Le mot de passe est requis
        </div>
      </div>

      <div class="form-options">
        <label class="remember-me">
          <input 
            type="checkbox" 
            [(ngModel)]="rememberMe" 
            name="rememberMe">
          <span>Se souvenir de moi</span>
        </label>
        <a routerLink="/forgot-password" class="forgot-password">Mot de passe oublié?</a>
      </div>

      <button 
        type="submit" 
        class="login-button" 
        [disabled]="loginForm.invalid || isLoading"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">Se connecter</span>
        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>
      </button>
    </form>

    <div class="divider">
      <span>ou</span>
    </div>

    <div class="signup-prompt">
      <p>Vous n'avez pas de compte?</p>
      <a routerLink="/signup" class="signup-link">
        Créer un compte
      </a>
    </div>
  </div>
</div> 